import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import {
  receivingList,
  sortingListCurrent,
  handleClickPaginator,
  handleChangeLimitOffset,
  handleSearchData,
  receivedSearch,
  clearAllStates,
} from "../actions/list";

import {
  addToCart,
  addToWish,
  addToCompare,
  removeFromWish,
  removeFromCompare,
} from "../actions/wishCompareCart";
import Pagination from "react-js-pagination";

import { withTranslation } from "react-i18next";
import i18n from "i18next";
import favIcon from "../images/fav_icon.svg";
import compareIcon from "../images/compare_icon.svg";
import defImage from "../images/no_image.png";
import { Link } from "react-router-dom";
import loader from "../images/loader.svg";
import { config } from "../config";
import Breadcrumb from "./breadcrumbs";


/**
 * Just a wrapper under list items
 *
 */
class ListGoods extends Component {
  /**
   *
   * @type {{isShowLoader: *, categoryData: {number, private, static, extends, public, protected, string, bool, constructor, interface, any}, list: string | f.elements.object | Object | CKEDITOR.tools.object | {findKey, merge} | number, orderingData: {number, private, static, extends, public, protected, string, bool, constructor, interface, any}}}
   */

  static propTypes = {
    listGoods: PropTypes.object,
    isShowLoader: PropTypes.bool,
    categoryData: PropTypes.string,
    orderingData: PropTypes.string,
    limitOffsetData: PropTypes.string,
    filtersUrl: PropTypes.string,
    sortingData: PropTypes.array,
    urlForChange: PropTypes.string,
    isChangeUrl: PropTypes.bool,
    pageNum: PropTypes.number,
    limit: PropTypes.string,
    search: PropTypes.string,
    history: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = { search: "" };
    this.timeout = 0;
  }

  doSearch(evt) {
    var searchText = evt.target.value; // this is the search text
    this.props.setSearchData(searchText);
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.handleChangeSearchInput(searchText);
    }, 1500);
  }

  /**
   * Component did update
   *
   * @param prevProps
   * @param prevState
   * @param snapshot
   */
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.isChangeUrl) {
      this.props.history.replace(this.props.urlForChange);
      window.scrollTo(0, 0);
    }

    if (this.props.filtersUrl !== prevProps.filtersUrl) {
      console.log("this.props.filterUrl", this.props.filtersUrl, prevProps.filtersUrl);
      this.props.getProductsList(
        this.props.categoryData,
        this.props.filtersUrl,
        i18n.language
      );
    }
  }

  /**
   * Mounting component and get all data
   *
   * @param nextProps
   */
  componentDidMount(nextProps) {
    console.log("category data ", this.props.categoryData);
    // console.log("component did i18n.languagei18n.languagei18n.language", i18n.language);
    this.props.getProductsList(
      this.props.categoryData,
      this.props.filtersUrl,
      i18n.language
    );
  }



  /**
   * Handle
   *
   * @param event
   */
  handleChangeSearchInput = (value) => {
    this.props.searchData(value);
  };



  /**
   * Renders just a list
   *
   * @returns {*}
   */
  render() {
    const { t } = this.props;
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          {/*<title>{this.props.listGoods.categoriesBredcrubs !== undefined?*/}
          {/*    this.props.listGoods.categoriesBredcrubs.breadcrumbs[this.props.listGoods.categoriesBredcrubs.breadcrumbs.length-1][`name${i18n.language.charAt(0).toUpperCase() + i18n.language.slice(1)}`]:''}</title>*/}
          {/*<meta property="og:title" content={this.props.listGoods.categoriesBredcrubs !== undefined?*/}
          {/*    this.props.listGoods.categoriesBredcrubs.breadcrumbs[this.props.listGoods.categoriesBredcrubs.breadcrumbs.length-1][`name${i18n.language.charAt(0).toUpperCase() + i18n.language.slice(1)}`]:''} />*/}
          {/*<meta property="og:url" content={this.props.listGoods.categoriesBredcrubs !== undefined?window.location.href:''}  />*/}
          <meta
            name="google-site-verification"
            content="ROi-AC8ntnzZkD8Ph7j6GUC3evYB1JzWgJM6TZSTVrM"
          />
        </Helmet>

        {Object.keys(this.props.listGoods).length ? (

          <Breadcrumb breadcrumbs={this.props.listGoods.categoriesBredcrubs.breadcrumbs} />

        ) : (
          ""
        )}
        <div>
          <div className="main-content-search  uk-position-relative uk-margin-bottom uk-hidden">
            <div className="search">
              <input
                className=" uk-input"
                onChange={(event) => this.doSearch(event)}
                type="search"
                name={"search"}
                value={this.props.search != null ? this.props.search : ""}
              />
            </div>
          </div>
          <div className="uk-flex uk-flex-middle uk-flex-wrap uk-flex-right@m uk-width-1-1 uk-child-width-auto@m uk-child-width-1-1  uk-margin-small-top">
            <div className="uk-flex uk-flex-middle uk-flex-right@m main-sort__first-item">
              <div className="sort-name">{t("list.sortBy")}:</div>
              <div
                className="sort-item "
                onClick={(event) => {
                  this.props.sortingProductsList(
                    "price",
                    this.props.sortingData
                  );
                }}
              >
                <span
                  className={
                    this.props.sortingData[0] === "price"
                      ? "price-active-" + this.props.sortingData[1]
                      : "inactive"
                  }
                ></span>
                {t("list.sortprice")}
              </div>
              <div
                className="sort-item"
                onClick={(event) => {
                  this.props.sortingProductsList(
                    "name",
                    this.props.sortingData
                  );
                }}
              >
                <span
                  className={
                    this.props.sortingData[0] === "name"
                      ? "name-active-" + this.props.sortingData[1]
                      : "inactive"
                  }
                ></span>
                {t("list.sortname")}
              </div>
            </div>

            <div className="uk-flex uk-flex-middle uk-flex-right@m">
              <div className="sort-name">{t("list.show")}:</div>
              <select
                className="sort-view-select uk-select uk-form-small"
                native
                value={this.props.limit}
                onChange={this.props.handleChangeLimit}
              >
                <option value={12}>12</option>
                <option value={24}>24</option>
                <option value={36}>36</option>

              </select>
            </div>
          </div>
        </div>
        <div className={this.props.isShowLoader ? "" : "uk-hidden"}>
          <div className="loader-overlay  uk-position-z-index">
            <div className="uk-position-center">
              <img className="loader-img" src={loader} uk-svg={""} alt={"loading..."} />
            </div>
          </div>
        </div>
        <div
          className="uk-child-width-1-4@l uk-child-width-1-3@m  uk-child-width-1-2 uk-grid-match uk-grid-small uk-margin-top "
          uk-grid="true"
        >
  
          {Object.keys(this.props.listGoods).length
            ? Object.keys(this.props.listGoods.pagination).map((itm, key) => (
              <div key={itm + "goods"}>
                <div className="product-card uk-card uk-card-small">
                  <div className="uk-card-media-top uk-text-center uk-padding-small">
                    <Link
                      to={
                        `/products/${i18n.language +
                        "/" +
                        this.props.listGoods.pagination[itm].category
                        }` +
                        "/item/" +
                        this.props.listGoods.pagination[itm].id
                      }
                    >
                      {/*<img className="good-image uk-height-small" src={defImage} title={this.props.listGoods.pagination[itm].nameProduct} alt={this.props.listGoods.pagination[itm].nameProduct} />*/}
                      <img
                        className="product-card__image uk-height-small"
                        src={
                          this.props.listGoods.pagination[itm].mainImage
                            ? config.assetsPrfix +
                            "img/products/min_" +
                            this.props.listGoods.pagination[itm].mainImage
                            : defImage
                        }
                        title={
                          this.props.listGoods.pagination[itm].nameProduct
                        }
                        alt={this.props.listGoods.pagination[itm].nameProduct}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = defImage
                        }}
                      />
                    </Link>
                  </div>
                  <div className="uk-card-body">
                    
                    <Link
                      className="product-card__name"
                      to={
                        `/products/${i18n.language +
                        "/" +
                        this.props.listGoods.pagination[itm].category
                        }` +
                        "/item/" +
                        this.props.listGoods.pagination[itm].id
                      }
                      title={this.props.listGoods.pagination[itm].nameProduct}
                    >
                      <h3>
                        {this.props.listGoods.pagination[itm].nameProduct}
                      </h3>
                    </Link>

                    <div className="product-card__price uk-flex uk-flex-between uk-flex-left@m">
                      <span>
                        {this.props.listGoods.dataPriceConvertedList[itm].price1 == 0.01 ? t('item.priceSpecify') : `${this.props.listGoods.dataPriceConvertedList[itm].price1} ${this.props.listGoods.currencyName}`}
                      </span>
                      <span className="product-card__price-discount">
                        {this.props.listGoods.dataPriceConvertedList[itm]
                          .price1 <
                          this.props.listGoods.dataPriceConvertedList[itm]
                            .price2 &&
                          this.props.listGoods.dataPriceConvertedList[itm]
                            .price2 > 0
                          ? this.props.listGoods.dataPriceConvertedList[itm]
                            .price2 +
                          " " +
                          this.props.listGoods.currencyName
                          : ""}
                      </span>
                    </div>
                    
                  </div>
                  <div className="product-card__stock-label">{t(this.props.listGoods.pagination[itm].stockInfo)}</div>
                  <div className="uk-card-footer">
                  
                    <div className="uk-flex uk-flex-middle uk-flex-between uk-flex-center@m uk-flex-wrap">
                      <button
                        className={`product-card__addtocart-btn ${!this.props.listGoods.pagination[itm].isInStock&&'product-card__addtocart-disable'} uk-width-1-1 uk-width-2-3@m uk-button uk-button-small uk-text-capitalize`}
                        onClick={(event) => {
                          this.props.addToCart(
                            this.props.listGoods.pagination[itm].id
                          );
                        }}
                        title={t("shop.addToCart")}
                        disabled={this.props.listGoods.pagination[itm].isInStock?false:true}
                      >
                        {t('shop.addToCart')}
                      </button>
                      {Object.keys(this.props.wishData).length &&
                        Object.keys(this.props.compareData).length ? (
                        <div
                          className={
                            "cart-footer-controls uk-flex uk-child-width-expand uk-width-1-3@m"
                          }
                        >
                          {this.props.wishData.data[
                            this.props.listGoods.pagination[itm].id
                          ] !== undefined ? (
                            <div
                              className="uk-text-center"
                              onClick={(event) =>
                                this.props.removeFomWish(
                                  event,
                                  this.props.listGoods.pagination[itm].id
                                )
                              }
                              title={t("shop.removeToFavorite")}
                            >
                              <img
                                alt={t("shop.addToFavorite")}
                                
                                className="product-card__footer-btn_img added-to-wishlist"
                                src={favIcon}
                                uk-svg=""
                              />
                            </div>
                          ) : (
                            <div
                              className="uk-text-center"
                              onClick={(event) => {
                                this.props.addToWish(
                                  event,
                                  this.props.listGoods.pagination[itm].id
                                )
                              }

                              }
                              title={t("shop.addToFavorite")}
                            >
                              <img
                                alt={t("shop.addToFavorite")}
                                
                                className="product-card__footer-btn_img add-to-wishlist"
                                src={favIcon}
                                uk-svg=""
                              />
                            </div>
                          )}
                          {this.props.compareData.data[
                            this.props.listGoods.pagination[itm].id
                          ] !== undefined ? (
                            <div
                              className="uk-text-center"
                              onClick={(event) => {
                                this.props.removeFromCompare(
                                  event,
                                  this.props.listGoods.pagination[itm].id
                                )
                              }

                              }
                              title={t("shop.removeToCompare")}
                            >
                              <img
                                className="product-card__footer-btn_img added-to-compare"
                                src={compareIcon}
                                uk-svg=""
                                alt={t("shop.removeToCompare")}
                              />
                            </div>
                          ) : (
                            <div
                              className="uk-text-center"
                              onClick={(event) => {
                                this.props.addToCompare(
                                  event,
                                  this.props.listGoods.pagination[itm].id
                                );

                              }

                              }
                              title={t("shop.addToCompare")}
                            >
                              <img
                                className="product-card__footer-btn_img add-to-compare"
                                src={compareIcon}
                                uk-svg=""
                                alt={t("shop.addToCompare")}
                              />
                            </div>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                     
                    </div>
                    {this.props.listGoods.pagination[itm].filtersArray && <>
                        <div className="product-card-filters">
                          <ul className="uk-list uk-margin-remove">
                            {this.props.listGoods.pagination[itm].filtersArray.map((itm) =>
                              <>
                                <li>
                                  <span className="product-card-filters__name">{itm.name}:</span> {itm.value}
                                </li>
                              </>
                            )}
                          </ul>
                        </div>
                      </>}
                  </div>
                </div>
              </div>
            ))
            : ""}
        </div>
        <div className="uk-container uk-width-1-1 uk-margin-top ">

          {this.props.isShowLoader === false &&
            Object.keys(this.props.listGoods.pagination).length ? (
            <Pagination
              innerClass="uk-pagination uk-flex-center"
              activePage={this.props.pageNum}
              itemsCountPerPage={this.props.listGoods.numItemsPerPage}
              totalItemsCount={this.props.listGoods.totalCount}
              pageRangeDisplayed={5}
              onChange={this.props.pageChangeClickPaginator}
            />
          ) : (
            <>
              <div className="uk-text-center">
                {this.props.isShowLoader === true && "...."}
                {this.props.isShowLoader === false && Object.keys(this.props.listGoods.pagination).length === 0 && t('shop.no_items_find')}
              </div>
            </>

          )}
        </div>
      </>
    );
  }
}

const myList = withTranslation("translations")(ListGoods);

/**
 *
 * @param dispatch
 * @returns {{getProductsList: getProductsList}}
 */
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getProductsList: (category, filters, language) => {
      //dispatch(clearAllStates());
      dispatch(
        receivingList(
          category,
          _convertUrlToFiltersStoreState(filters),
          language
        )
      );
    },

    sortingProductsList: (sortBy, orderingData) => {
      let newSort = [];
      // console.log( orderingData);
      if (orderingData[0] === sortBy) {
        newSort = [sortBy, orderingData[1] === "asc" ? "desc" : "asc"];
      } else {
        newSort = [sortBy, "asc"];
      }
      dispatch(sortingListCurrent(newSort));
    },
    addToCart: (id) => {
      dispatch(addToCart(id, false));
    },
    removeFomWish: (event, id) => {
      dispatch(removeFromWish(id));
    },
    addToWish: (event, id) => {
      dispatch(addToWish(id));
    },
    addToCompare: (event, id) => {
      dispatch(addToCompare(id));
    },
    removeFromCompare: (event, id) => {
      dispatch(removeFromCompare(id));
    },
    searchData: (value) => {
      dispatch(handleSearchData(value));
    },

    setSearchData: (value) => {
      dispatch(receivedSearch(value));
    },

    pageChangeClickPaginator: (page) => {
      dispatch(handleClickPaginator(page));
    },
    handleChangeLimit: (event) => {
      dispatch(handleChangeLimitOffset(event.target.value));
    },
  };
};

const _convertUrlToFiltersStoreState = (query) => {
  let data = [];
  if (query) {
    var filterSelected = [];
    var minMaxSelected = [];
    var conditionSelected = [];
    var regex = new RegExp("(filter=).*?(?=&|$)", "gm");
    var filtersPart = query.match(regex);
    console.log("filters part 85", filtersPart);
    if (filtersPart != null) {
      filtersPart[0]
        .replace("filter=", "")
        .split("+")
        .forEach((item, index) => {
          let tmp_ = item.split("-");
          console.log( "tmp _ item split ", tmp_ );
          if (tmp_.length === 2) {
            const parsed = isNaN(parseInt(tmp_[1]))?tmp_[1]:parseInt(tmp_[1]);
            filterSelected.push(parsed);
            conditionSelected.push(tmp_[0] + "-" + tmp_[1]);
          } else {
            if (minMaxSelected[tmp_[0]] === undefined) {
              minMaxSelected[tmp_[0]] = [];
            }
            minMaxSelected[tmp_[0]][tmp_[1]] = tmp_[2];
          }
        });
      console.log( "filters Selected ", filterSelected );
      data["storeMinMax"] = Object.assign({}, minMaxSelected);
      data["conditionSelected"] = conditionSelected;
      data["filtersSelected"] = filterSelected;
    }

    var regex = new RegExp("(sorting=).*?(?=&|$)", "gm");
    var sortingPart = query.match(regex);
    // console.log( "sorting Part ", sortingPart );
    if (sortingPart != null) {
      var sortingString = sortingPart[0].split("sorting=")[1].split("+");
      // console.log("sortingString", sortingString);
      data["sorting"] = sortingString;
    }

    regex = new RegExp("(page=).*?(?=&|$)", "gm");
    var pageLimitPart = query.match(regex);
    if (pageLimitPart != null) {
      data["pageNum"] = parseInt(pageLimitPart[0].split("page=")[1]);
    }

    regex = new RegExp("(limit=).*?(?=&|$)", "gm");
    var limitPart = query.match(regex);
    if (limitPart != null) {
      data["limit"] = limitPart[0].split("limit=")[1];
    }

    regex = new RegExp("(search=).*?(?=&|$)", "gm");
    var searchPart = query.match(regex);
    if (searchPart != null) {
      data["search"] = searchPart[0].split("search=")[1];
    }

    regex = new RegExp("(searchArt=).*?(?=&|$)", "gm");
    var searchPart = query.match(regex);
    if (searchPart != null) {
      data["searchArt"] = searchPart[0].split("searchArt=")[1];
    }


    regex = new RegExp("(is_discount=).*?(?=&|$)", "gm");
    var isDiscountPart = query.match(regex);
    if (isDiscountPart != null) {
      data['is_discount'] = isDiscountPart[0].split("is_discount=")[1];
    }

    data["filterPart"] = query;

  }

  // console.log("URL:LLLLLL ", data);
  return data;
};

/**
 *
 * @param store
 * @returns {{listGoods: *, isShowLoader: *}}
 */
const mapStateToProps = (store) => {
  const {
    listGoods,
    search,
    isShowLoader,
    sortingData,
    urlForChange,
    isChangeUrl,
    pageNum,
    limit,
  } = store.goods;
  const { wishData, cartData, compareData } = store.wishCompareCart;
  // console.log("sortingDatasortingDatasortingDatasortingData ", wishData);
  return {
    listGoods: listGoods,
    isShowLoader: isShowLoader,
    sortingData: sortingData,
    urlForChange: urlForChange,
    isChangeUrl: isChangeUrl,
    pageNum: pageNum,
    limit: limit,
    search: search,
    wishData,
    cartData,
    compareData,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(myList);
